import clsx from 'clsx';
import { Container } from '@material-ui/core';
import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import BackButton from '../../BackButton/BackButton';
import { Typography, Title, useIsMobile } from 'ui-components';

import useStyles from './ProductWizardTitle.style';

const ProductWizardTitle: FunctionComponent<{
  titleKey: string,
  className?: string,
  titleClassName?: string,
  subtitle?: string,
  onBackButtonClick?: () => void,
  showBackButton?: boolean,
}> = ({titleKey, className, titleClassName, onBackButtonClick, subtitle, showBackButton = true }) => {

  const c = useStyles({});
  const [t] = useTranslation('product-wizard');
  const isMobile = useIsMobile();

  return (
    <Container maxWidth={false} className={className}>
      <Container maxWidth="lg" className={c.titleWrapper}>
        {showBackButton && <BackButton onBackButtonClick={() => onBackButtonClick}/>}
        <Title
          title={t(`title.${titleKey}`)}
          titleVariant={isMobile ? 'h2' : 'h1'}
          titleComponent="h1"
          titleClassName={clsx(c.title, titleClassName)}
          align={isMobile ? 'left' : 'center'}
          titleFontWeight="extraBold"
        />
          {!!subtitle && <Typography
                          variant="body1"
                          textColor="greys.60"
                          align="center"
                          className={c.subtitle}
                       >
                        {subtitle}
                      </Typography>
          }
      </Container>
    </Container>
  );
};

export { ProductWizardTitle };
